import React from 'react';
import './GrayButton.scss'
import {FaSortDown} from 'react-icons/fa'
import Loading from "../../Loading/Loading";

const GrayButton = ({className, id, name, style, onClick, loading = false, disabled = false, showDropDownIcon = false}) => (
  <div className={'gray-button-main-container ' + className}
       id={id}
       style={style}>
    <button className="gray-button-main"
            style={{visibility:loading ? 'hidden' : 'visible'}}
            onClick={onClick}
            disabled={loading || disabled}>
      {name}
    
      {showDropDownIcon ?
        <FaSortDown className="gray-button-icon-down"/>
        :
        null
      }
    </button>
  
    <Loading className="gray-button-loading"
             loading={loading}
             showLabel={false}
    />
  </div>
);

export default GrayButton;
